import { Button, SimpleDialog, Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { ViewSubSection } from "shared/components";
import { useDangerZone, UseDangerZoneProps } from "./useDangerZone";
import { WarningTriangle } from "iconoir-react";
import { Flex } from "styled-system/jsx";

export const DangerZone = ({ person, onDeleted }: UseDangerZoneProps) => {
  const { t } = useTranslation("people", {
    keyPrefix: "PERSON_DETAILS_MODAL.DANGER_ZONE",
  });

  const {
    isConfirmingDelete,
    isDeleting,
    showDangerZone,
    isRemoveDisabled,
    handleConfirmDelete,
    handleConfirmResponse,
  } = useDangerZone({
    person,
    onDeleted,
  });

  if (!showDangerZone) return null;

  return (
    <>
      <ViewSubSection title={t("TITLE")} description={t("DESCRIPTION")}>
        <Flex direction="column" gap="300" alignItems="flex-start">
          <Button
            visual="destructive"
            isLoading={isDeleting}
            onClick={handleConfirmDelete}
            w="fit-content"
            disabled={isRemoveDisabled}
          >
            {t("CTA_BUTTON_COPY")}...
          </Button>
          {isRemoveDisabled && (
            <Text visual="smallRegular" color="text.mid">
              {t("DISABLED_REASON")}
            </Text>
          )}
        </Flex>
      </ViewSubSection>
      <SimpleDialog
        open={isConfirmingDelete}
        Icon={WarningTriangle}
        title={t("CONFIRM_MODAL.TITLE")}
        message={t("CONFIRM_MODAL.MESSAGE")}
        cancelButtonCopy={t("CONFIRM_MODAL.BTN_CANCEL")}
        onCancelClick={() => handleConfirmResponse(false)}
        confirmButtonCopy={t("CONFIRM_MODAL.BTN_CONFIRM")}
        confirmButtonVisual="destructive"
        onConfirmClick={() => handleConfirmResponse(true)}
        portal
      />
    </>
  );
};
